// extracted by mini-css-extract-plugin
module.exports = {"textField":"TextField_textField__1SVwQ","text":"TextField_text__1s6jM","alightRight":"TextField_alightRight__1_sfp"};